/**
 * De eventcatalogus van de eVilla-site: één plek waar alle namen en hun
 * metadata staan. Namen zijn snake_case en beschrijven wat de bezoeker deed,
 * niet welk component toevallig geraakt werd.
 *
 * Voeg je een event toe, doe dat hier eerst: `track()` accepteert alleen namen
 * die in deze catalogus staan, en de delegated clicklistener weigert
 * `data-analytics-event`-waarden die hier niet in voorkomen.
 */

export const analyticsEventNames = [
  "hero_cta_clicked",
  "route_selected",
  "project_router_started",
  "project_router_completed",
  "price_calculator_started",
  "price_calculator_completed",
  "project_uploaded",
  "consultation_requested",
  "professional_route_opened",
  "case_viewed",
  "package_viewed",
] as const;

export type AnalyticsEventName = (typeof analyticsEventNames)[number];

/**
 * Elk event zegt uit welk component het komt; `page`, `route` en `ts` schrijft
 * de verzendlaag erbij. De veldnamen hieronder komen uit de Analytics-tabel van
 * U1 en zijn daar de afspraak, niet hier.
 */
type Base = { component: string };

export type AnalyticsEventPayloads = {
  hero_cta_clicked: Base & { cta_label: string; href?: string };
  /** `source` scheidt de routekaarten op de homepage van de projectrouter. */
  route_selected: Base & { selected_route: string; source: "cards" | "router" };
  project_router_started: Base & { entry_page: string };
  project_router_completed: Base & { selected_route: string; rol: string; steps_completed: number };
  price_calculator_started: Base;
  /** `pakket` blijft leeg zolang de calculator alle drie de pakketten tegelijk toont. */
  price_calculator_completed: Base & { volume_m3: number; pakket?: string };
  project_uploaded: Base & { file_count: number };
  consultation_requested: Base & {
    delivery: "api" | "mailto";
    phase: string;
    selected_route?: string;
    pakketindicatie?: string;
  };
  professional_route_opened: Base & { rol?: string };
  case_viewed: Base & { case_slug: string; case_type: "gebouwd" | "studie" };
  package_viewed: Base & { pakket: string };
};

export function isAnalyticsEventName(value: string): value is AnalyticsEventName {
  return (analyticsEventNames as readonly string[]).includes(value);
}
